import bilAPI from "./api";


export const getQuestions = ({
  params: { page, page_size, author, topic, objective, purpose, subject, status, search, grade, evaluator, ordering, folder, test, exclude_test, subtopic, passage, has_passage, difficulty, task, task_left },
  signal,
}) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .get(`/questions/questions/`, {
          params: { page, page_size, author, topic, objective, purpose, subject, status, search, grade, evaluator, ordering, folder, test, exclude_test, subtopic, passage, has_passage, difficulty, task, task_left },
          signal,
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const getQuestionByUUID = ({ uuid, evaluator, signal }) => {
  return new Promise((resolve, reject) => {
    try {
      const params = {};
      if (evaluator) {
        params.evaluator = evaluator;
      }

      bilAPI
        .get(`/questions/questions/${uuid}/`, { 
          signal,
          params 
        })
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    } catch (error) {
      reject(error);
    }
  });
};

export const getQuestionHistoryByUUID = ({ uuid, signal }) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .get(`/questions/questions/${uuid}/status_history/`, { signal })
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    } catch (error) {
      reject(error);
    }
  });
};

export const postStatusUpdateByUUID = ({ uuid, body, signal }) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .post(`/questions/questions/${uuid}/update_status/`, body, { signal })
        .then((res) => resolve(res?.data))
        .catch((err) => {
          if (err.name === "CanceledError") return;
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};


export const getPurposes = ({
  params: { page, page_size },
  signal,
}) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .get(`/questions/question_purposes/`, {
          params: { page, page_size },
          signal,
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const getStatuses = ({
  params: { page, page_size },
  signal,
}) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .get(`/questions/question_statuses/`, {
          params: { page, page_size },
          signal,
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const getObjectives = ({
  params: { page, page_size},
  signal,
}) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .get(`/questions/question_objectives/`, {
          params: { page, page_size},
          signal,
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const getSubjects = ({
  params: { page, page_size },
  signal,
}) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .get(`/questions/subjects/`, {
          params: { page, page_size },
          signal,
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const getTopics = ({
  params: { page, page_size, grade, subject, search },
  signal,
}) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .get(`/questions/topics/`, {
          params: { page, page_size, grade, subject, search },
          signal,
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const getSubtopics = ({
  params: { page, page_size, topic, search },
  signal,
}) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .get(`/questions/subtopics/`, {
          params: { page, page_size, topic, search },
          signal,
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const getStatusCount = ({
  params: { page, page_size, author, topic, grade, subject, objective, purpose, status, search, folder, test, exclude_test, subtopic, passage, has_passage, difficulty, task, task_left },
  signal,
}) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .get(`/questions/status_count/`, {
          params: { page, page_size, author, topic, grade, subject, objective, purpose, status, search, folder, test, exclude_test, subtopic, passage, has_passage, difficulty, task, task_left },
          signal,
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const postQuestionVote = (uuid, body) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .post(`/questions/questions/${uuid}/vote/`, body)
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};


// `fields` (folder, subject, subtopic, purpose, objective) apply to every question in the file; empty values are skipped.
// `signal` (optional) cancels the request.
export const uploadFileWithQuestions = (file, fields = {}, signal) => {
  const formData = new FormData();
  formData.append('file', file);
  Object.entries(fields).forEach(([key, value]) => {
    if (value) formData.append(key, value);
  });
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .post(`/questions/questions/upload_file_with_questions/`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
          signal,
        })
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    } catch (error) {
      reject(error);
    }
  });
};

export const getEvaluatorStats = ({
  params: { page, page_size },
  signal,
}) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .get(`/questions/evaluators_stats/`, {
          params: { page, page_size },
          signal,
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};


export const getEvaluators = ({
  params: { page, page_size, search, domain_subject, ordering },
  signal,
}) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .get(`/questions/evaluators/`, {
          params: { page, page_size, search, domain_subject, ordering },
          signal,
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          if (err.name === "AbortError") return;
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};


export const getEvaluatorQuestionsByUUID = ({ 
  uuid, 
  params: { page, page_size, search, evaluation_value, status } = {},
  signal 
}) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .get(`/questions/evaluators/${uuid}/questions/`, {
          params: { page, page_size, search, evaluation_value, status },
          signal,
        })
        .then((res) => resolve(res.data))
        .catch((err) => {
          if (err.name === "AbortError") return;
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

// Question folders: exams (parent null) and their subjects (parent = the exam's uuid). Questions and passages
// live in subjects only. The `folder` and `subject` list filters also accept the string "null"
// ("No folder" / "No subject"); `folder` = an exam's uuid gives the questions of all its subjects.
const json = { headers: { "Content-Type": "application/json" } };

// A flat list: each exam followed by its subjects, with the user's `role` in each subject.
// `params.author` = my uuid -> questions_count counts only my questions (including my drafts).
export const getQuestionFolders = ({ params, signal } = {}) =>
  bilAPI.get(`/questions/question_folders/`, { params, signal }).then((res) => res.data);

export const getQuestionFolder = (uuid, { signal } = {}) =>
  bilAPI.get(`/questions/question_folders/${uuid}/`, { signal }).then((res) => res.data);

// Admin only: an exam ({name}, optionally with its other fields, e.g. approved_only_in_tests) or a subject in
// an exam ({parent, subject_uuid}).
export const createQuestionFolder = (name, fields = {}) =>
  bilAPI.post(`/questions/question_folders/`, { ...fields, name }, json).then((res) => res.data);

// A subject for one stream ("kk" КАЗ, "ru" РУС) or both (null); the same subject and stream twice → 400 {subject_uuid}.
export const addSubjectFolder = (parent, subjectUuid, stream = null) =>
  bilAPI.post(`/questions/question_folders/`, { parent, subject_uuid: subjectUuid, stream }, json).then((res) => res.data);

// Admin only: changes an exam's fields — `name`, `approved_only_in_tests` («only approved questions in its tests»,
// which its subjects show as theirs) — or a subject's `stream`, until variants are built from it (else 400 {stream}).
// A subject has no name or approved_only_in_tests of its own: 400 {name: [...]} / {approved_only_in_tests: [...]}.
export const updateQuestionFolder = (uuid, fields) =>
  bilAPI.patch(`/questions/question_folders/${uuid}/`, fields, json).then((res) => res.data);

// Exams only; a subject takes its subject's name.
export const renameQuestionFolder = (uuid, name) => updateQuestionFolder(uuid, { name });

export const deleteQuestionFolder = (uuid) =>
  bilAPI.delete(`/questions/question_folders/${uuid}/`).then((res) => res.data);

// All or nothing. `folder` is a subject or null (No folder).
export const moveQuestionsToFolder = ({ questions, folder }) =>
  bilAPI.post(`/questions/questions/move_to_folder/`, { questions, folder }, json).then((res) => res.data);

// A subject's matrix (v2: a row is a week of a grade with a topic and its subtopics, or no topic yet): GET for every
// role, PUT ({rows: [{grade?, topic: uuid | null, subtopics: [uuid], quarter, week, hours, planned}], revision},
// replaces it whole) for its moderator and admins; both answer with the matrix. A PUT made from an older `revision`
// (someone saved meanwhile) → 409 matrix_changed.
export const getFolderMatrix = (uuid, { signal } = {}) =>
  bilAPI.get(`/questions/question_folders/${uuid}/matrix/`, { signal }).then((res) => res.data);

export const saveFolderMatrix = (uuid, rows, revision) =>
  bilAPI.put(`/questions/question_folders/${uuid}/matrix/`, { rows, revision }, json).then((res) => res.data);

// Replaces the matrix with a copy of another subject folder's of the same catalog subject (e.g. the other stream's):
// 400 subject_mismatch for another subject, 400 {source} for one the user cannot see. Answers with the matrix.
export const copyFolderMatrix = (uuid, source) =>
  bilAPI.post(`/questions/question_folders/${uuid}/matrix/copy/`, { source }, json).then((res) => res.data);

// Sharing a subject (its moderator and admins): {members, link: {role, token}, can_grant_moderator}.
export const getFolderAccess = (uuid, { signal } = {}) =>
  bilAPI.get(`/questions/question_folders/${uuid}/access/`, { signal }).then((res) => res.data);

// Adds the user (201) or changes their role (200).
export const setFolderMember = (uuid, user, role) =>
  bilAPI.post(`/questions/question_folders/${uuid}/access/members/`, { user, role }, json).then((res) => res.data);

export const removeFolderMember = (uuid, userUuid) =>
  bilAPI.delete(`/questions/question_folders/${uuid}/access/members/${userUuid}/`).then((res) => res.data);

// "Anyone with the link": a role turns it on (with a new token) or changes it, null turns it off.
// Answers like getFolderAccess.
export const setFolderLink = (uuid, role) =>
  bilAPI.put(`/questions/question_folders/${uuid}/access/link/`, { role }, json).then((res) => res.data);

// Up to 20 active accounts that can be added (not students, not members yet).
export const getFolderCandidates = (uuid, search, { signal } = {}) =>
  bilAPI
    .get(`/questions/question_folders/${uuid}/access/candidates/`, { params: { search: search || undefined }, signal })
    .then((res) => res.data);

// Questions the user reads, as a test a student sees (nothing is saved): up to 100 uuids, in that order (a passage's
// questions together). {test_questions: [{uuid, order, points, question}], passages: [{uuid, name, body}], points,
// skipped: [{uuid, reason: "not_found" | "draft"}]}; 400 {code}: questions_required, questions_invalid,
// too_many_questions.
export const getQuestionsPreview = (uuids, { signal } = {}) =>
  bilAPI.get(`/questions/questions/preview/`, { params: { questions: uuids.join(",") }, signal }).then((res) => res.data);

// A subject's tasks (TZ 2.2): its moderator and admins see all of them and give, change and cancel them; an author
// or an expert sees their own; a viewer gets 403. A task is "write" (questions of a matrix row, {A, B, C} of them)
// or "review" (the questions of chosen authors, or chosen questions). Not paged; by due date (none last), then by
// creation.
export const getFolderTasks = (uuid, { includeCancelled = false, signal } = {}) =>
  bilAPI
    .get(`/questions/question_folders/${uuid}/tasks/`, { params: { include_cancelled: includeCancelled || undefined }, signal })
    .then((res) => res.data);

// {kind: "write", assignee, row, planned: {A, B, C}, due_date?, comment?} or {kind: "review", assignee, authors: [uuid]
// or questions: [uuid], due_date?, comment?}: 201 with the task, 400 {code: "invalid_task", reason}
// (folders.tasks.errors.<reason>).
export const createFolderTask = (uuid, body) =>
  bilAPI.post(`/questions/question_folders/${uuid}/tasks/`, body, json).then((res) => res.data);

// Only planned (write), authors or questions (review, as it was given), due_date and comment change.
export const updateFolderTask = (uuid, taskUuid, fields) =>
  bilAPI.patch(`/questions/question_folders/${uuid}/tasks/${taskUuid}/`, fields, json).then((res) => res.data);

// Cancels it (204); one cancelled already → 404.
export const cancelFolderTask = (uuid, taskUuid) =>
  bilAPI.delete(`/questions/question_folders/${uuid}/tasks/${taskUuid}/`).then((res) => res.data);

// The user's own active tasks in every subject; `done` true / false narrows them.
export const getMyTasks = ({ done, signal } = {}) =>
  bilAPI.get(`/questions/question_folders/my_tasks/`, { params: { done }, signal }).then((res) => res.data);

// Joins by an invite link's token: {folder, role}.
export const joinQuestionFolder = (token) =>
  bilAPI.post(`/questions/question_folders/join/`, { token }, json).then((res) => res.data);

export const getSubjectCount = ({ params, signal } = {}) =>
  bilAPI.get(`/questions/subject_count/`, { params, signal }).then((res) => res.data);
